import {
    mapMeasurementUnit,
    useAnalyzerStore,
    useGetCriteriaLabel,
    useGetCriteriaLevelColor,
    useGetMeasurement,
    useTranslateMeasurements,
} from 'app/hooks/useAnalyzer'
import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import moment from 'moment'
import {
    Chip,
    InputAdornment,
    Link,
    Stack,
    styled,
    TablePagination,
    TextField,
} from '@mui/material'
import { SearchOutlined } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom'
import AnalyzerToolbar from './AnalyzerToolbar'

const ContentBox = styled('div')(({ theme }) => ({
    margin: '30px',
    gap: '2px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
}))

const DataTable = ({ isHideFilterHeader }) => {
    const { data } = useGetMeasurement()
    const { setPage, setLimit, page, limit, setSearch } = useAnalyzerStore()
    const { format } = useTranslateMeasurements()
    const { format: formatCriteriaLabel } = useGetCriteriaLabel()
    const { format: formatColor } = useGetCriteriaLevelColor()
    const { format: formatUint } = mapMeasurementUnit()
    return (
        <ContentBox>
            <Stack gap={2}>
                {!isHideFilterHeader && <AnalyzerToolbar />}
                <TextField
                    className="print-area-none "
                    onChange={(e) => {
                        const value = e.target.value
                        if (value === '') return setSearch(null)
                        setSearch(value)
                    }}
                    type="number"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchOutlined />
                            </InputAdornment>
                        ),
                    }}
                    label="ค้นหาจากหมายเลขประจำตัว (CID)"
                    variant="outlined"
                />
                {/* TODO: filter with measure type หมายเลขบัตรประชาชน,ประเภาการตรวจคัดกรอง	 */}
                <TableContainer sx={{ padding: 2 }} component={Paper}>
                    <Table sx={{ minWidth: 980 }} aria-label="ตารางข้อมูล">
                        <TableHead>
                            <TableRow>
                                <TableCell>หมายเลขบัตรประชาชน</TableCell>
                                <TableCell>วันที่ตรวจ</TableCell>
                                <TableCell>ชื่อ-นามสกุล</TableCell>
                                <TableCell>ประเภาการตรวจคัดกรอง</TableCell>
                                <TableCell>ผลตรวจ</TableCell>
                                <TableCell>สรุปผลการตรวจ</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.items?.map((row) => {
                                const k = row.measurements
                                    .map((measure) => measure.name)
                                    .join(',')
                                const c = formatCriteriaLabel(row.measurements)
                                return (
                                    <TableRow
                                        key={row._id}
                                        sx={{
                                            '&:last-child td, &:last-child th':
                                                {
                                                    border: 0,
                                                },
                                        }}
                                    >
                                        <TableCell>
                                            <Link
                                                component={RouterLink}
                                                to={
                                                    '/dashboard/patient/' +
                                                    row.cid
                                                }
                                            >
                                                {row.cid}
                                            </Link>
                                        </TableCell>

                                        <TableCell component="th" scope="row">
                                            {moment
                                                .unix(row.mea_timestamp)
                                                .format('DD/MM/YYYY')}
                                        </TableCell>
                                        <TableCell>--</TableCell>
                                        <TableCell>{format(k)}</TableCell>
                                        <TableCell>
                                            {row.measurements
                                                .map((measure) => measure.value)
                                                .join('/')}
                                            {'  '}
                                            {formatUint(k)}
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                sx={{
                                                    color: 'white',
                                                    backgroundColor:
                                                        formatColor(c.level),
                                                }}
                                                label={c.label}
                                            />
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Stack>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={data?.total || 0}
                rowsPerPage={limit}
                page={page - 1}
                onPageChange={(_, page) => setPage(page + 1)}
                onRowsPerPageChange={(e) =>
                    setLimit(parseInt(e.target.value, 10))
                }
            />
        </ContentBox>
    )
}

export default DataTable
